module.exports = __webpack_public_path__ + "img/guizhouHints_15.a40430de.jpg";